import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

const SuccessPayment = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [counter, setCounter] = useState(30);

  const countDown = () => {
    if (counter === 0) {
      return;
    }
    setTimeout(() => {
      setCounter(counter - 1);
    }, 1000);

    return (
      <p className="auto-close">
        {t("this page will automatically close in")} {counter} {t("seconds")}
      </p>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      navigate("/generateqr");
    }, 10000);
  });

  return (
    <div className="payment success">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth={0} />
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <g id="SVGRepo_iconCarrier">
          <path
            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#66ab67"
            strokeWidth={1.5}
          />
          <path
            d="M9 12L10.6828 13.6828V13.6828C10.858 13.858 11.142 13.858 11.3172 13.6828V13.6828L15 10"
            stroke="#66ab67"
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </svg>
      <h3>{t("payment succeeded")}</h3>
      <p>{t("payment succeeded description")}</p>
      {countDown()}
      <hr />
      <Link to="/generateqr">{t("ok")}</Link>
    </div>
  );
};

export default SuccessPayment;
